import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../../components/Hyperlink';

type Props = {
  errorMessage: string;
  errorType: string;
};

export class SignUpError extends React.Component<Props> {
  render() {
    return (
      <div className="form-error is-visible signup-form__error">
        {this.props.errorMessage}
        {this.props.errorType === 'EMAIL_ALREADY_USED' && (
          <>
            {' '}
            <FormattedMessage id="signup/routes/user/form/SignUpError.tsx/1" />{' '}
            <Hyperlink
              className="form-error signup-form__error__link"
              href="/connexion?source=signup-error"
            >
              <FormattedMessage id="signup/routes/user/form/SignUpError.tsx/2" />
            </Hyperlink>
          </>
        )}
      </div>
    );
  }
}
